import { notification, Typography } from 'antd';
import { WarningOutlined, CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const defaultNotificationProps = {
  duration: 5,
  placement: 'topRight',
  style: { borderRadius: '10px', width: '355px' },
};

const { Text } = Typography;

/**
 * Notificaciones de ANTD con la configuración predeterminada usada en la app
 * @returns
 */
const useNotify = () => {
  const { t } = useTranslation('translations');
  const openErrorNotify = (message: string) => {
    notification.error({
      ...defaultNotificationProps,
      message: <Text>{message}</Text>,
      style: { ...defaultNotificationProps.style },
      icon: <WarningOutlined style={{ color: '#FF4D4D' }} />,
    } as any);
  };

  const openSuccessNotify = (message = t('msg-alert.msg_exitoso')) => {
    notification.success({
      ...defaultNotificationProps,
      message: <Text>{message}</Text>,
      style: { ...defaultNotificationProps.style },
      icon: <CheckOutlined style={{ color: '#02BF80' }} />,
    } as any);
  };

  return { openErrorNotify, openSuccessNotify };
};

export { useNotify };
